import { useState, useEffect, useCallback } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { Changelog } from '@/types/supabase';

export const useChangelogs = () => {
  const [changelogs, setChangelogs] = useState<Changelog[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);

  const fetchChangelogs = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const { data, error } = await supabase
        .from('changelogs')
        .select('*')
        .order('release_date', { ascending: false });

      if (error) throw error;
      setChangelogs(data || []);
    } catch (err: any) {
      setError(err);
      console.error('Error fetching changelogs:', err);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchChangelogs();
  }, [fetchChangelogs]);

  return { changelogs, loading, error, refetch: fetchChangelogs };
};